import {MessagesEn} from "./messages.en";

export const Locales = {
    en: MessagesEn
}